import { useMutation, useQueryClient } from "@tanstack/react-query";
import type { AdminAreaView } from "@/lib/api/types";
import { endpoints } from "@/lib/api/endpoints";
import { apiJsonClient } from "@/lib/query/core/api-json-client";
import { invalidateAdminAreas } from "@/lib/query/core/invalidation";

type CreateAreaInput = {
  governorateId: string;
  nameAr: string;
  nameEn?: string;
  isActive?: boolean;
};

export function useCreateAreaMutation() {
  const queryClient = useQueryClient();
  const mutation = useMutation({
    mutationFn: (input: CreateAreaInput) =>
      apiJsonClient<AdminAreaView>(endpoints.admin.areas, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(input),
      }),
    onSuccess: async () => {
      await invalidateAdminAreas(queryClient);
    },
  });

  return {
    mutateAsync: mutation.mutateAsync,
    isPending: mutation.isPending,
    error: mutation.error,
    reset: mutation.reset,
  };
}
